import UserFormView from './UserFormView.vue';

export default UserFormView;